// extracted by mini-css-extract-plugin
export default {"cardBase":"common_cardBase__oLB+W","buyBtn":"common_buyBtn__j4RKJ","carddBtn":"common_carddBtn__9CjNq","cardHover":"common_cardHover__87CJp"};